const MoreVerticalSquare01Icon = /*#__PURE__*/ [
  ["rect", { x: "10.5", y: "3", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["rect", { x: "10.5", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["rect", { x: "10.5", y: "18", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export { MoreVerticalSquare01Icon as default };
//# sourceMappingURL=MoreVerticalSquare01Icon.js.map
